module.exports = window.wp.url;